import { render, staticRenderFns } from "./real_device.vue?vue&type=template&id=4696cd1a&scoped=true&"
import script from "./real_device.vue?vue&type=script&lang=js&"
export * from "./real_device.vue?vue&type=script&lang=js&"
import style0 from "./real_device.vue?vue&type=style&index=0&id=4696cd1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4696cd1a",
  null
  
)

export default component.exports